/**
 * /messages and /messages/:threadId (staff chat MVP, SR-14): deep links only. There is no Messages page any more; the
 * conversations live in the Team dock. The link opens the dock (on the thread when one is named) and goes to home,
 * replacing itself in the history, so Back never lands on an empty route. With `?x=staff-chat` off it only goes home.
 */
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useHomePath } from '@/shared/lib/home-path';
import { useDockStore } from '@/staff-chat/lib/dock-store';
import { isStaffChatOn } from '@/staff-chat/lib/staff-chat-switch';

export function MessagesDeepLink() {
  const { threadId } = useParams<{ threadId?: string }>();
  const home = useHomePath();
  const openDock = useDockStore((s) => s.openDock);
  const on = isStaffChatOn();
  // Synchronises the dock (state outside this route) with the link that was opened.
  useEffect(() => {
    if (on) openDock(threadId ?? null);
  }, [on, threadId, openDock]);
  return <Navigate to={home} replace />;
}
